import { Location } from '@/types/models/Location.model'
import { isLocationCity } from '@/domain/location/useCases/isLocationCity'

export const generateCustomizedTermData = (
  location: Location
): { type: string; title: string }[] => {
  const locationToExclude =
    isLocationCity(location) && location.parentLocation
      ? location.parentLocation
      : location.title

  const termData = [
    { type: 'NOT locations', title: 'United States' },
    { type: 'amenities', title: 'Luxury' },
    { type: 'NOT locations', title: 'Canada' }
  ]

  if (locationToExclude && locationToExclude !== 'Canada') {
    termData.push({ type: 'NOT locations', title: locationToExclude })
  }
  return termData
}
